const Image = "/images/PhotoGalleries/2025/2025-kitchener-waterloo/1.jpg";

export default [
  {
    info: (
      <div className="single-gallery__info">
        <p className="single-gallery__text">
          On May 8, 2025 in Kitchener/Waterloo at ABE ERB
        </p>

        {/* <p className="single-gallery__text">Special thanks to our sponsors:</p> */}

        <img
          className="single-gallery__sponsor-image--large"
          src={Image}
          alt="Kitchener waterloo event patrons"
        />
      </div>
    ),
    subtitle: "2025 Kitchener Waterloo Networking Event",
    photos: [
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/1.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/2.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/3.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/4.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/5.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/6.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/7.jpg",
      },
      {
        photo: "/images/PhotoGalleries/2025/2025-kitchener-waterloo/8.jpg",
      },
    ],
  },
];
